import { asyncAction, action } from 'now-frontend-shared/utils/actions';

// async actions
export const addListingPageView = asyncAction('listingAnalytics/ADD_LISTING_PAGE_VIEW');
export const addListingDocumentDownload = asyncAction('listingAnalytics/ADD_LISTING_DOCUMENT_DOWNLOAD');
export const getListingAnalytics = asyncAction('listingAnalytics/GET_ANALYTICS');

// sync actions
export const clearListingAnalyticsState = action('listingAnalytics/CLEAR_STATE');
